<template>
  <div class="css-grid sales-chart__container">
    <ChartCustom v-if="showTrend" :chart-settings="chartConfig" class="chart__trend"></ChartCustom>
    <span v-else><h3>Notice:</h3>Please run a report that includes more than 1 months data to view the trend. You can adjust this using the "Sales Range" filter.</span>
  </div>
</template>



<script>
  import ChartCustom from '../../general/ChartCustom.vue';

  export default {
    name: 'TrendVendors',
    components: {
      ChartCustom,
    },
    props: ['formattedData', 'showTrend'],
    computed: {
      chartConfig() {
        return {
          size: { height: 388 },
          padding: { top: 20 },
          data: {
            json: this.formattedData,
            x: 'months',
            type: 'spline',
            colors: {
              Oticon: '#D50D8C',
              Phonak: '#7FC241',
              ReSound: '#D71921',
              Widex: '#87693C',
              Unitron: '#00CCFF',
              Sonic: '#415968',
              Signia: '#A12223'
            },
          },
          axis: {
            x: {
              type: 'timeseries',
              tick: {
                format: '%b %y',
              }
            },
            y : {
              tick: {
                format: d3.format(",.0f"),
                count: 7,
              },
              show: false
            },
          },
          tooltip: {
            format: {
              title: function (d) {
                return moment(d).format("MMM YYYY") + ' Units';
              },
            }
          },
          point: { r: 6 },
          legend: { show: true, position: 'bottom' }
        };
      },
    },
  };
</script>
